import React, { useState, useEffect } from 'react';

function AssignSlotModal({ slot, zoneId, workshopId, employees, onAssign, onClose }) {
  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Фильтруем: только сотрудники этого цеха без слота
    const list = employees.filter((e) => {
      // Должен быть без слота
      if (e.slot_id) return false;
      // Должен быть ИЗ ЭТОГО цеха (не из общего хаба)
      if (e.workshop_id !== workshopId) return false;
      // Поиск
      if (search) {
        const s = search.toLowerCase();
        return (
          (e.full_name || '').toLowerCase().includes(s) ||
          (e.tab_number || '').toLowerCase().includes(s)
        );
      }
      return true;
    });
    
    // Сортируем по ФИО
    list.sort((a, b) => (a.full_name || '').localeCompare(b.full_name || ''));
    setFiltered(list);
  }, [employees, search, workshopId]);

  const getInitials = (fullName) => {
    if (!fullName) return '?';
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  const handleAssign = async (emp) => {
    setLoading(true);
    await onAssign(emp);
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
  👤 Кого назначить на место: <br />
  <span style={{ fontSize: '13px', color: '#6c757d', fontWeight: 500 }}>
    {slot.section_name} → {slot.role_name} №{slot.slot_number}
  </span>
</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Поиск */}
          <div className="filters" style={{ marginBottom: '12px' }}>
            <input
              type="text"
              className="filter-search"
              placeholder="🔍 Поиск по ФИО или табельному..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
            />
            {search && (
              <button className="btn-clear" onClick={() => setSearch('')}>
                ✖ Сбросить
              </button>
            )}
          </div>

          {/* Список сотрудников */}
          {filtered.length === 0 ? (
            <div className="empty" style={{ padding: '30px' }}>
              {search
                ? 'Никого не найдено'
                : 'Нет доступных сотрудников. Сначала переведите их в этот цех.'}
            </div>
          ) : (
            <div className="assign-employees-list">
              {filtered.map((emp) => (
                <div
                  key={emp.id}
                  className="assign-employee-item"
                  onClick={() => handleAssign(emp)}
                >
                  <div className={`emp-avatar ${emp.gender === 'м' ? 'male' : 'female'}`}>
                    {getInitials(emp.full_name)}
                  </div>
                  <div className="assign-employee-info">
                    <div className="assign-employee-name">
                      {emp.full_name}
                    </div>
                    <div className="assign-employee-meta">
                      {emp.tab_number && <span>📋 {emp.tab_number}</span>}
                      {emp.workshop_name && <span>🏭 {emp.workshop_name}</span>}
                      {emp.is_vakhta && <span className="badge badge-vakhta">Вахта</span>}
                    </div>
                  </div>
                  <div className="assign-employee-action">
                    👉
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <div className="modal-footer-right">
            <button className="btn-cancel" onClick={onClose}>
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssignSlotModal;